import type { ISidebarProps } from './Sidebar'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { BaseCardSC } from 'blocks/Cards'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import { SidebarPosition } from './Sidebar.h'

const DESKTOP_CARDS_COUNT = 5
const TABLET_CARDS_COUNT = 4

export const SidebarStyled = styled.div<
  Pick<ISidebarProps, 'paddings' | 'width' | 'height' | 'position'>
>`
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  overflow: hidden;
  width: ${({ width }) => (width ? width : 'min-content')};
  height: ${({ height }) => (height ? height : 'auto')};

  > ${TextBoxSC} {
    margin-bottom: var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MAX_1239} {
    display: none;
  }

  // sidebar positioning
  position: ${({ position }) =>
    position !== undefined ? 'absolute' : 'static'};
  top: ${({ position }) =>
    position === SidebarPosition.TopLeft ||
    position === SidebarPosition.TopRight
      ? 0
      : 'auto'};
  left: ${({ position }) =>
    position === SidebarPosition.TopLeft ||
    position === SidebarPosition.BottomLeft
      ? 0
      : 'auto'};
  right: ${({ position }) =>
    position === SidebarPosition.TopRight ||
    position === SidebarPosition.BottomRight
      ? 0
      : 'auto'};
  bottom: ${({ position }) =>
    position === SidebarPosition.BottomLeft ||
    position === SidebarPosition.BottomRight
      ? 0
      : 'auto'};
`

export const SidebarBodyStyled = styled.div<
  Pick<ISidebarProps, 'rowGap'> & { sidebarBodyHeight: string }
>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ rowGap }) => `var(${rowGap || FIXED_INDENTS.INDENT_0})`};
  overflow: hidden;

  --sidebar-card-height: ${({ sidebarBodyHeight, rowGap }) =>
    sidebarBodyHeight
      ? `calc((${sidebarBodyHeight} - var(${rowGap}) * ${
          TABLET_CARDS_COUNT - 1
        }) / ${TABLET_CARDS_COUNT})`
      : 'auto'};

  ${MEDIA.MIN_1640} {
    --sidebar-card-height: ${({ sidebarBodyHeight, rowGap }) =>
      sidebarBodyHeight
        ? `calc((${sidebarBodyHeight} - var(${rowGap}) * ${
            DESKTOP_CARDS_COUNT - 1
          }) / ${DESKTOP_CARDS_COUNT})`
        : 'auto'};
  }

  ${MEDIA.MAX_1639} {
    /* Styles for card or wrapped in link card*/
    & > ${BaseCardSC}:nth-child(${DESKTOP_CARDS_COUNT}),
    & > a:nth-child(${DESKTOP_CARDS_COUNT}) {
      display: none;
    }
  }
`
